import { LitElement as b, css as g, unsafeCSS as v, html as f } from "lit";
import { property as n } from "lit/decorators/property.js";
import { ifDefined as x } from "lit/directives/if-defined.js";
import { ValidationLevel as k } from "@smartdesign/field-validation-message";
const y = ":host{display:block}:host,.label,.checkbox{outline:none}:host([disabled]){pointer-events:none}:host([disabled]) .root{opacity:.6;cursor:default;filter:grayscale(100%)}:host(:not([disabled])[focused]) .highlight{display:block!important}:host([checked]) circle.inner{display:block!important}:host([checked]) circle.outer{stroke:var(--sd-radio-button-checked-color, #1467ba)!important}.root{display:inline-flex;align-items:center;vertical-align:middle;width:100%;padding-top:6px;padding-bottom:6px}.root .radio-button-container{position:relative;display:inline-block;width:28px;height:28px;box-sizing:border-box;cursor:pointer;margin-right:5px;flex-shrink:0}.root .radio-button-container input{position:absolute;top:0;left:0;opacity:0}.root .radio-button-container circle.highlight{stroke:var(--sd-radio-button-highlight-color, rgba(20, 103, 186, .3))}.root .radio-button-container circle.inner{fill:var(--sd-radio-button-checked-color, #1467ba)}.root .radio-button-container circle.outer{stroke:var(--sd-radio-button-unchecked-color, #767676)}.root .label{font-family:Segoe UI,Lucida Sans,Arial,sans-serif;text-overflow:ellipsis;overflow-x:hidden;-webkit-user-select:none;user-select:none;cursor:pointer;padding-top:2px;padding-bottom:2px}";
var I = Object.defineProperty, m = Object.getOwnPropertyDescriptor, p = (o, t, e, s) => {
  for (var i = s > 1 ? void 0 : s ? m(t, e) : t, c = o.length - 1, d; c >= 0; c--)
    (d = o[c]) && (i = (s ? d(t, e, i) : d(i)) || i);
  return s && i && I(t, e, i), i;
};
let w = 0;
var a;
const u = (a = class extends b {
  constructor() {
    super(), this.checked = !1, this.value = "", this.disabled = !1, this.label = "", this.handleClick = (t) => {
      t.preventDefault();
    }, this.a11yID = a.ID + "_" + w++;
  }
  static get styles() {
    return [
      g`
                ${v(y)}
            `
    ];
  }
  render() {
    return f`
            <div class="root">
                <div class="radio-button-container">
                    <input
                        type="radio"
                        id="${this.a11yID}"
                        .checked="${this.checked}"
                        ?disabled="${this.disabled}"
                        @click="${this.handleClick}"
                        class="radio-button"
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-14 -14 28 28">
                        <circle
                            class="highlight"
                            style="display:none"
                            r="11px"
                            fill="transparent"
                            stroke-width="6px"
                        ></circle>
                        <circle class="inner" r="6px" style="display:none" stroke="none"></circle>
                        <circle class="outer" r="9px" fill="transparent" stroke-width="2px"></circle>
                    </svg>
                </div>
                <label class="label" for="${this.a11yID}" @click="${this.handleClick}">${this.label}</label>
            </div>
        `;
  }
}, a.ID = "sd-radio-button", a.ensureDefined = () => {
  customElements.get(a.ID) || customElements.define(a.ID, a);
}, a);
p([
  n({ type: Boolean, reflect: !0, attribute: !0 })
], u.prototype, "checked", 2);
p([
  n({ type: String, reflect: !0, attribute: !0 })
], u.prototype, "value", 2);
p([
  n({ type: Boolean, reflect: !0, attribute: !0 })
], u.prototype, "disabled", 2);
p([
  n({ type: String, reflect: !0, attribute: !0 })
], u.prototype, "label", 2);
let B = u;
const _ = ":host(:focus){outline:none}.buttons-container{display:flex}.buttons-container.vertical{flex-direction:column}.validation-message{margin-left:5px}";
var C = Object.defineProperty, D = Object.getOwnPropertyDescriptor, h = (o, t, e, s) => {
  for (var i = s > 1 ? void 0 : s ? D(t, e) : t, c = o.length - 1, d; c >= 0; c--)
    (d = o[c]) && (i = (s ? d(t, e, i) : d(i)) || i);
  return s && i && C(t, e, i), i;
}, l;
const r = (l = class extends b {
  constructor() {
    super(...arguments), this.layout = "horizontal", this.value = "", this.uncheckAllowed = !1, this.disabled = !1, this._focusIndex = -1, this._checkedButton = null, this.handleSlotChange = () => {
      this._buttons = this.buttonsSlot.assignedElements(), this._buttons.forEach((t) => {
        !t.hasAttribute("disabled") && this.disabled && t.setAttribute("disabled", ""), t.setAttribute("tabIndex", "-1"), this.updateCheckedButton(t);
      });
    }, this.handleFocusIn = (t) => {
      const e = t.target, s = this._buttons.findIndex((i) => i == e);
      this.focusIndex = this.focusIndex >= 0 ? this.focusIndex : this.getNextFocusIndex(s !== -1 ? s : 0), this.updateFocused(null, this._buttons[this.focusIndex]);
    }, this.handleFocusOut = () => {
      this.updateFocused(this._buttons[this.focusIndex]);
    }, this.handleButtonClick = (t) => {
      this.focus();
      const e = this._buttons.find((i) => i.contains(t.target)), s = this._buttons.findIndex((i) => i == e);
      s >= 0 && (this.focusIndex = s, this.updateChecked());
    }, this.handleKeyDown = (t) => {
      let e = !0;
      switch (t.key) {
        case "Down":
        case "ArrowDown": {
          const s = this.getNextFocusIndex(this.focusIndex + 1);
          this.focusIndex = s !== -1 ? s : this.getNextFocusIndex(0), this.uncheckAllowed || this.updateChecked();
          break;
        }
        case "Up":
        case "ArrowUp": {
          const s = this.getPreviousFocusIndex(this.focusIndex - 1);
          this.focusIndex = s !== -1 ? s : this.getPreviousFocusIndex(this.childElementCount - 1), this.uncheckAllowed || this.updateChecked();
          break;
        }
        case "Enter": {
          this.updateChecked();
          break;
        }
        default:
          e = !1;
      }
      e && (t.preventDefault(), t.stopPropagation());
    };
  }
  get focusIndex() {
    return this._focusIndex;
  }
  set focusIndex(t) {
    if (t >= -1 && t < this.childElementCount) {
      const e = this._focusIndex;
      if (this._focusIndex = t, e !== t) {
        const s = this._buttons[e], i = this._buttons[this.focusIndex];
        this.updateFocused(s, i);
      }
    }
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.buttonsSlot.addEventListener("slotchange", this.handleSlotChange), this.addEventListener("focusin", this.handleFocusIn), this.addEventListener("focusout", this.handleFocusOut), this.addEventListener("keydown", this.handleKeyDown);
  }
  updated(t) {
    super.updated(t), t.has("disabled") && (this.disabled ? this.disableButtons() : this.enableButtons());
  }
  static get styles() {
    return [
      g`
                ${v(_)}
            `
    ];
  }
  render() {
    return f`
            <div
                class="buttons-container ${this.layout === "vertical" ? "vertical" : "horizontal"}"
                @click="${x(this.disabled ? void 0 : this.handleButtonClick)}"
            >
                <slot></slot>
            </div>
            ${this.validationMessage && f`
                <sd-field-validation-message
                    class="validation-message"
                    .message=${this.validationMessage}
                    .icon=${this.validationIconSrc}
                    .level=${this.validationLevel}
                >
                </sd-field-validation-message>
            `}
        `;
  }
  updateCheckedButton(t) {
    if (this._checkedButton && this._checkedButton !== t)
      this.uncheckButton(t);
    else if (t.hasAttribute("checked")) {
      this._checkedButton = t;
      const e = t.getAttribute("value");
      this.updateValue(e);
    }
  }
  disableButtons() {
    var t;
    (t = this._buttons) == null || t.forEach((e) => {
      e.setAttribute("disabled", "");
    });
  }
  enableButtons() {
    var t;
    (t = this._buttons) == null || t.forEach((e) => {
      e.removeAttribute("disabled");
    });
  }
  fireValueChangeEvent() {
    this.dispatchEvent(
      new CustomEvent("value-change", {
        detail: {
          value: this.value,
          selectedIndex: this.selectedIndex
        }
      })
    );
  }
  getNextFocusIndex(t) {
    for (let e = t; e < this.childElementCount; e++) {
      const s = this._buttons[e];
      if (this.isFocusable(s))
        return e;
    }
    return -1;
  }
  getPreviousFocusIndex(t) {
    for (let e = t; e >= 0; e--) {
      const s = this._buttons[e];
      if (this.isFocusable(s))
        return e;
    }
    return -1;
  }
  isFocusable(t) {
    return !t.hasAttribute("disabled");
  }
  updateChecked() {
    const t = this._checkedButton, e = this._buttons[this.focusIndex];
    this._checkedButton = e, t && t !== e && this.uncheckButton(t), e && this.toggleButton(e);
  }
  toggleButton(t) {
    t.hasAttribute("checked") ? this.uncheckAllowed && (this.uncheckButton(t), this._checkedButton = null, this.updateValue("")) : (this.checkButton(t), this.updateValue(t.getAttribute("value")));
  }
  updateValue(t) {
    this.value = t, this.fireValueChangeEvent();
  }
  updateFocused(t, e) {
    var s, i;
    (s = t == null ? void 0 : t.removeAttribute) == null || s.call(t, "focused"), (i = e == null ? void 0 : e.setAttribute) == null || i.call(e, "focused", "");
  }
  checkButton(t) {
    t.setAttribute("checked", "");
  }
  uncheckButton(t) {
    t.removeAttribute("checked");
  }
  get buttonsSlot() {
    return this.shadowRoot && !this._buttonsSlot && (this._buttonsSlot = this.shadowRoot.querySelector("slot")), this._buttonsSlot;
  }
  get selectedIndex() {
    return this._buttons.indexOf(this._checkedButton);
  }
}, l.ID = "sd-radio-button-group", l.ensureDefined = () => {
  B.ensureDefined(), customElements.get(l.ID) || customElements.define(l.ID, l);
}, l);
h([
  n({ type: String, reflect: !0, attribute: !0 })
], r.prototype, "layout", 2);
h([
  n({ type: String })
], r.prototype, "value", 2);
h([
  n({ type: Boolean, reflect: !0, attribute: "uncheck-allowed" })
], r.prototype, "uncheckAllowed", 2);
h([
  n({ type: Boolean, reflect: !0, attribute: !0 })
], r.prototype, "disabled", 2);
h([
  n({ type: String })
], r.prototype, "validationMessage", 2);
h([
  n({ type: String })
], r.prototype, "validationIconSrc", 2);
h([
  n({
    type: {
      fromAttribute(o) {
        return o && k[o.toLowerCase()];
      },
      toAttribute(o) {
        return o && o.toLowerCase();
      }
    },
    reflect: !0
  })
], r.prototype, "validationLevel", 2);
let A = r;
A.ensureDefined();
export {
  B as RadioButton,
  A as RadioButtonGroup
};
//# sourceMappingURL=radio-button-group.mjs.map
